import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapPin, ChevronRight } from "lucide-react";
import api from "@/lib/api";
import AIContentBlock from "@/components/AIContentBlock";

export default function Explore() {
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    api.get("/countries").then((r) => setCountries(r.data)).catch(console.error);
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="explore-page">
      <p className="text-xs font-bold uppercase tracking-[0.3em] text-slate-500 mb-3">Explore by Place</p>
      <h1 className="font-display text-4xl sm:text-5xl font-black text-slate-900">One World. <span className="gradient-text">A Million Sounds.</span></h1>
      <p className="mt-3 text-slate-600 max-w-2xl">Every country page connects the music of a place with the people who create it — drill into states, provinces and cities to find local traditions.</p>

      <AIContentBlock pageKey="explore" topic="Exploring world music by place — countries, regions and cities" imgQuery="world travel culture music street" />

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-10">
        {countries.map((c) => (
          <Link key={c.slug} to={`/places/${c.slug}`} data-testid={`country-card-${c.slug}`} className="card-lift bg-white rounded-3xl border border-slate-100 overflow-hidden group">
            <div className="h-44 overflow-hidden relative">
              <img src={c.image} alt={c.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-950/70 via-transparent to-transparent" />
              <div className="absolute bottom-3 left-4 flex items-center gap-2">
                <span className="text-2xl">{c.flag}</span>
                <h2 className="font-display text-2xl font-black text-white">{c.name}</h2>
              </div>
            </div>
            <div className="p-5">
              <p className="text-sm text-slate-600 line-clamp-2">{c.description}</p>
              <div className="flex flex-wrap gap-1.5 mt-3">
                {c.featured_genres?.slice(0, 3).map((g) => (
                  <span key={g} className="px-2.5 py-1 rounded-full bg-pink-50 text-pink-700 text-[11px] font-bold">{g}</span>
                ))}
              </div>
              <p className="mt-4 text-xs font-bold text-slate-500 flex items-center gap-1">
                <MapPin className="w-3.5 h-3.5 text-pink-500" />
                {c.states?.length} regions · {c.states?.reduce((n, s) => n + s.cities.length, 0)} cities
                <ChevronRight className="w-4 h-4 ml-auto text-slate-300 group-hover:text-pink-500 transition-colors" />
              </p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
